<template>
  <BreadCrumb PageTitle="Colors" />
  <ColorsContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import ColorsContent from "../../template-components/Utilities/Colors/ColorsContent.vue";

export default defineComponent({
  name: "ColorsPage",
  components: {
    BreadCrumb,
    ColorsContent,
  },
});
</script>